import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

// Instruction Languages APIs
export const getAllLanguages = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/instruction-languages`);
        return response.data;
    } catch (error) {
        console.error("Error fetching languages:", error);
        throw error;
    }
};

export const createLanguage = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/instruction-languages`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getLanguageById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/instruction-languages/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateLanguage = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/instruction-languages/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteLanguage = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/instruction-languages/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
